exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dollorPriceAlignmnet {\n  display: flex;\n  justify-content: flex-end;\n  white-space: normal;\n  word-break: break-all;\n}\n.personsCount{\n  margin-right: 50px !important;\n}\n", ""]);

// exports
